import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import * as styles from "./style.module.scss";
import UISwitch from "@/components/ui-controls/ui-switch";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsMuted,
  toggleMute,
} from "@/store/slices/notifications/notificationsSlice";
import IconButton from "@mui/material/IconButton";
import { VolumeUp, VolumeOff } from "@mui/icons-material";
import Check from "@mui/icons-material/Check";
import Box from "@mui/material/Box";

const Header = ({ selected, onChange, onMarkAllAsRead, unreadCount }) => {
  return (
    <ListItem
      key={"main-title"}
      style={{ paddingBottom: 0 }}
      alignItems="flex-start"
    >
      <ListItemText
        primary={
          <HeaderPrimary
            selected={selected}
            onChange={onChange}
            onMarkAllAsRead={onMarkAllAsRead}
            unreadCount={unreadCount}
          />
        }
        // secondary={<HeaderButtons selected={selected} onChange={onChange} />}
      />
    </ListItem>
  );
};
export default Header;

const HeaderPrimary = ({
  selected,
  onChange,
  onMarkAllAsRead,
  unreadCount,
}) => {
  const dispatch = useDispatch();
  const isMuted = useSelector(selectIsMuted);

  const handleMuteToggle = () => {
    dispatch(toggleMute());
  };

  return (
    <Typography component="span" className={styles?.headerPrimary}>
      <Typography
        className={styles?.menuHeading}
        sx={{ display: "inline" }}
        variant="h3"
        fontWeight={500}
        color="custom.heading"
      >
        Notifications
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {unreadCount > 0 && (
          <Typography
            component="span"
            className={styles?.markAll}
            onClick={onMarkAllAsRead}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onMarkAllAsRead();
              }
            }}
          >
            <Check fontSize="small" />
            Mark all as read
          </Typography>
        )}
        <UISwitch
          name="unread"
          checked={selected === "unread"}
          size="sm"
          label="Only see unread"
          handleChange={onChange}
          defaultStyled={false}
        />
        {/* <IconButton
          onClick={handleMuteToggle}
          size="small"
          sx={{ color: "var(--palette-grey_text)" }}
          aria-label={isMuted ? "Unmute notifications" : "Mute notifications"}
        >
          {isMuted ? (
            <VolumeOff fontSize="small" />
          ) : (
            <VolumeUp fontSize="small" />
          )}
        </IconButton> */}
      </Box>
    </Typography>
  );
};

const HeaderButtons = ({ selected, onChange }) => {
  return (
    <Typography component={"span"} className={styles?.btnContainer}>
      {HeaderBtnOptions.filter((item) => item.name !== "unread").map((opt) => (
        <Button
          key={opt?.id}
          name={opt?.name}
          className={`${styles.headerBtn} ${
            opt.name === selected && styles.btnSelected
          }`}
          onClick={onChange}
        >
          {opt?.title}
        </Button>
      ))}
    </Typography>
  );
};

const HeaderBtnOptions = [
  { id: 1, title: "Direct", name: "direct" },
  { id: 2, title: "Unread", name: "unread" },
  { id: 3, title: "Following", name: "following" },
];
